import * as React from "react";
import { Box } from "@material-ui/core";
import FaqModel from "../../core/models/Faq";
import { EVENT_FAQ_SEARCH_CHANGE } from "../../Events";
import { useHubXSubscribe } from "../../HubX";
import FaqAccordionItem from "./FaqAccordionItem";

type FaqAccordionProps = {
  faqs: FaqModel[];
  startOpen?: boolean;
};

function FaqAccordion({ faqs }: FaqAccordionProps) {
  const [searchFilter, SetFilter] = React.useState<string>("");
  useHubXSubscribe(EVENT_FAQ_SEARCH_CHANGE, SetFilter);

  const filteredFaqs = faqs
    .filter((cond) => {
      return (
        cond.question.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1 ||
        cond.answer.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1
      );
    })
    .map((filter) => filter);

  return (
    <Box mt={3}>
      {filteredFaqs.map((faq, idx) => (
        <FaqAccordionItem key={faq.question} startOpen={idx === 0} faq={faq} />
      ))}
    </Box>
  );
}

export default FaqAccordion;
